import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { INTEGRATION_TYPES } from '../../../../constants/apiRoutes';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';
/**
 * list Integration Type.
 * @returns {Promise} - A promise that resolves with the list of Integration Type or rejects with an error.
 * @param props
 */
export const listIntegrationTypes = async ({
  limit,
  offset,
  filter,
  sort,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const data = {
    Filters: filter,
    pageNumber: offset === 0 ? 1 : offset,
    pageSize: limit,
    sort,
  };
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${INTEGRATION_TYPES}/Filter`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    integrationTypes: response.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * Create Integration Type.
 * @returns {Promise} - A promise that resolves with the creation of integration type or rejects with an error.
 * @param data
 */
export const createIntegrationType = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${INTEGRATION_TYPES}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update Integration Type.
 * @returns {Promise} - A promise that resolves with the update of integration type or rejects with an error.
 * @param data
 */
export const updateIntegrationType = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${INTEGRATION_TYPES}/${data?.SysType}`,
    method: 'PUT',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Delete Integration Type.
 * @returns {Promise} - A promise that resolves with the update of integration type or rejects with an error.
 * @param data
 */
export const deleteIntegrationType = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${INTEGRATION_TYPES}/${data?.SysType}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Get Integration Type.
 * @returns {Promise} - A promise that resolves with the update of integration type or rejects with an error.
 * @param data
 */
export const getIntegrationType = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${INTEGRATION_TYPES}/${data?.SysType}`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};
